module.exports = __webpack_public_path__ + "img/vip.028d5f02.svg";